import { createFeatureSelector, createSelector } from '@ngrx/store';
import { cyberAssetsFeatureKey } from './cyber-assets.reducer';
import { CyberAssetsState } from './cyber-assets.reducer';

export const getCyberAssetsState = createFeatureSelector<CyberAssetsState>(
  cyberAssetsFeatureKey,
);

export const getCyberAssets = createSelector(
  getCyberAssetsState,
  (state) => state.cyberAssets,
);

export const getCyberAssetsIsLoading = createSelector(
  getCyberAssetsState,
  (state) => state.assetsIsLoading ?? true,
);

export const getCyberAssetsIsUpdating = createSelector(
  getCyberAssetsState,
  (state) => state.assetsIsUpdating ?? false,
);

export const getCyberAssetsPagination = createSelector(
  getCyberAssetsState,
  (state) => state.pagination,
);

export const getCyberAssetsFilterOptions = createSelector(
  getCyberAssetsState,
  (state) => state.filterOptions,
);

export const getAssetDetails = createSelector(
  getCyberAssetsState,
  (state) => state.assetDetails,
);

export const getAssetDetailsIsLoading = createSelector(
  getCyberAssetsState,
  (state) => state.assetDetailsIsLoading,
);

export const getAssetDetailsLoadError = createSelector(
  getCyberAssetsState,
  (state) => state.assetDetailsLoadError,
);

export const getAssetDetailsCommentPending = createSelector(
  getCyberAssetsState,
  (state) => state.assetDetailsCommentPending,
);

export const getAssetDetailsCommentFailed = createSelector(
  getCyberAssetsState,
  (state) => state.assetDetailsCommentFailed,
);

export const getAssetDetailsNewComment = createSelector(
  getCyberAssetsState,
  (state) => state.assetDetailsNewComment,
);

export const getNeedUpdate = createSelector(
  getCyberAssetsState,
  (state) => state.needUpdate,
);

export const getSelectedAssetId = createSelector(
  getCyberAssetsState,
  (state) => state.selectedAssetId,
);
